import type { Session } from '../types/session';

interface ChatHeaderProps {
  session: Session;
  onEndSession: () => void;
  onAddTime: (minutes: number) => void;
  onAddNote: () => void;
  mode?: 'default' | 'user';
}

export default function ChatHeader({ session, onEndSession, onAddTime, onAddNote, mode = 'default' }: ChatHeaderProps) {
  return (
    <header className="px-3 sm:px-4 py-2.5 sm:py-3 border-b border-border-soft flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2.5 sm:gap-3 bg-gradient-to-r from-[#070814]/95 to-[#0a0c16]/90 backdrop-blur-sm flex-shrink-0">
      <div className="flex gap-2.5 sm:gap-3 items-center min-w-0">
        {/* Consultant avatar */}
        {session.consultantImage ? (
          <img
            src={session.consultantImage}
            alt={session.client}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover border-2 border-accent/40 shadow-[0_0_14px_rgba(226,183,20,0.18)] flex-shrink-0"
          />
        ) : (
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-accent to-[#e86fde] flex items-center justify-center text-[0.82rem] sm:text-[0.88rem] font-semibold flex-shrink-0 shadow-[0_0_14px_rgba(226,183,20,0.18)]">
            {session.client.substring(0, 2).toUpperCase()}
          </div>
        )}

        <div className="flex flex-col gap-0.5 min-w-0">
          <div className="text-[0.85rem] sm:text-[0.92rem] font-medium flex items-center gap-1.5 sm:gap-2 flex-wrap">
            <span className="truncate max-w-[120px] sm:max-w-none">{session.client}</span>
            <span className="inline-flex items-center gap-1 text-[0.62rem] sm:text-[0.68rem] px-1.5 sm:px-2 py-0.5 rounded-full border border-success/50 text-success bg-success/5 flex-shrink-0">
              <span className="w-1.5 h-1.5 rounded-full bg-success animate-pulse" />
              Em curso
            </span>
          </div>
          <div className="text-[0.68rem] sm:text-[0.73rem] text-text-soft truncate">
            {session.theme || 'Consulta de Tarot'}
          </div>
          <div className="flex gap-1 sm:gap-1.5 flex-wrap mt-0.5">
            <div className="text-[0.62rem] sm:text-[0.68rem] px-1.5 sm:px-2 py-0.5 rounded-full border border-border-soft bg-white/[0.02] text-text-soft">
              Início: {session.startTime}
            </div>
            <div className="text-[0.62rem] sm:text-[0.68rem] px-1.5 sm:px-2 py-0.5 rounded-full border border-border-soft bg-white/[0.02] text-text-soft">
              Decorridos: {session.duration}
            </div>
            <div className="text-[0.62rem] sm:text-[0.68rem] px-1.5 sm:px-2 py-0.5 rounded-full border border-accent/30 bg-accent/5 text-accent">
              Saldo: <strong>{session.balance}</strong>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-2 items-center justify-end flex-shrink-0">
        {mode === 'default' && (
          <>
            <div className="hidden lg:flex gap-1 bg-[#0a0b16]/95 p-0.5 rounded-full border border-border-soft text-[0.72rem]">
              <div className="flex-1 text-center px-3 py-1 rounded-full cursor-pointer bg-gradient-to-br from-accent-soft to-transparent text-text">
                Vista Consultor
              </div>
              <div className="flex-1 text-center px-3 py-1 rounded-full cursor-pointer text-text-soft">
                Vista Admin
              </div>
            </div>
            <button 
              onClick={() => onAddTime(5)}
              className="hidden sm:inline-flex px-3 py-1.5 rounded-full border border-border-soft bg-[#0c0d18]/90 text-text text-[0.7rem] cursor-pointer hover:bg-white/5 transition-colors"
            >
              + 5 min oferta
            </button>
            <button 
              onClick={onAddNote}
              className="hidden sm:inline-flex px-3 py-1.5 rounded-full border border-border-soft bg-[#0c0d18]/90 text-text text-[0.7rem] cursor-pointer hover:bg-white/5 transition-colors"
            >
              Registar nota
            </button>
          </>
        )}
        <button 
          onClick={onEndSession}
          className="px-3 py-1.5 rounded-lg border border-danger/70 bg-[#0c0d18]/90 text-danger text-[0.7rem] sm:text-[0.75rem] cursor-pointer hover:bg-danger/10 transition-colors"
        >
          Finalizar Chat
        </button>
      </div>
    </header>
  );
}
